import { render, staticRenderFns } from "./CategoryListBox.vue?vue&type=template&id=b4757478&scoped=true"
import script from "./CategoryListBox.vue?vue&type=script&lang=js"
export * from "./CategoryListBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4757478",
  null
  
)

export default component.exports